import { getColor } from "../../../../../../../../utils/getColor";

export const scaleArrowsAxes = {
	id: "scaleArrowsAxes",
	beforeDatasetsDraw(chart) {
		const textColor = getColor("primary", 9); // "#102430";
		const lineColor = getColor("neutral", 4); // "#9197A1";
		const {
			ctx,
			chartArea: { top, bottom, left, right },
		} = chart;

		ctx.save();
		ctx.lineWidth = 1;
		ctx.strokeStyle = lineColor;
		ctx.fillStyle = lineColor;

		const sideLength = 5;
		const scaleLabelLeft = left - 16;
		const scaleLabelBottom = bottom + 16;

		const arrowTop = top + 40;
		const arrowBottom = bottom - 40;
		const arrowLeft = left + 38;
		const arrowRight = right - 40;

		// Calculate height of the equilateral triangle
		const height = (Math.sqrt(3) / 2) * sideLength;

		// write the word "High" at the top vertically
		ctx.save();
		ctx.translate(scaleLabelLeft + sideLength / 2, arrowTop - 12);
		ctx.textBaseline = "middle";
		ctx.fillStyle = textColor;
		ctx.rotate(-Math.PI / 2);
		ctx.fillText("High", 0, 0);
		ctx.restore();

		// Start at the top left point after text.
		ctx.beginPath();
		ctx.moveTo(scaleLabelLeft + sideLength / 2, arrowTop);

		// Draw the equilateral triangle
		ctx.lineTo(scaleLabelLeft, arrowTop + height);
		ctx.lineTo(scaleLabelLeft + sideLength, arrowTop + height);
		ctx.lineTo(scaleLabelLeft + sideLength / 2, arrowTop);

		// Close the path and fill the triangle
		ctx.closePath();
		ctx.fill();

		// draw a line to the bottom of the scale
		ctx.beginPath();
		ctx.moveTo(scaleLabelLeft + sideLength / 2, arrowTop);
		ctx.lineTo(scaleLabelLeft + sideLength / 2, arrowBottom);
		ctx.stroke();

		// add the bottom triangle
		ctx.moveTo(scaleLabelLeft + sideLength / 2, arrowBottom);
		ctx.lineTo(scaleLabelLeft, arrowBottom - height);
		ctx.lineTo(scaleLabelLeft + sideLength, arrowBottom - height);
		ctx.lineTo(scaleLabelLeft + sideLength / 2, arrowBottom);

		ctx.closePath();
		ctx.fill();

		// write the word "Low" at the bottom vertically
		ctx.save();
		ctx.translate(scaleLabelLeft + sideLength / 2, arrowBottom + 12);
		ctx.textBaseline = "middle";
		ctx.textAlign = "right";
		ctx.fillStyle = textColor;
		ctx.rotate(-Math.PI / 2);
		ctx.fillText("Low", 0, 0);
		ctx.restore();

		// repeat but for the bottom axis
		ctx.moveTo(scaleLabelLeft + sideLength / 2, arrowBottom);
		ctx.lineTo(right, arrowBottom - height);
		ctx.lineTo(right - sideLength, arrowBottom - height);
		ctx.lineTo(scaleLabelLeft + sideLength / 2, arrowBottom);

		ctx.closePath();
		ctx.fill();

		// write the word "Low" at the bottom left horizontally
		ctx.save();
		ctx.translate(arrowLeft - 12, scaleLabelBottom - sideLength / 2);
		ctx.textBaseline = "middle";
		ctx.textAlign = "right";
		ctx.fillStyle = textColor;
		ctx.fillText("Low", 0, 0);
		ctx.restore();

		// begin the X scale at the true bottom and arrowLeft leaving space for text
		ctx.moveTo(arrowLeft, scaleLabelBottom - sideLength / 2);
		// draw the equilateral triangle pointing left
		ctx.lineTo(arrowLeft + height, scaleLabelBottom);
		ctx.lineTo(arrowLeft + height, scaleLabelBottom - sideLength);
		ctx.lineTo(arrowLeft, scaleLabelBottom - sideLength / 2);
		ctx.closePath();
		ctx.fill();

		// draw a line to the right of the axis
		ctx.beginPath();
		ctx.moveTo(arrowLeft, scaleLabelBottom - sideLength / 2);
		ctx.lineTo(arrowRight, scaleLabelBottom - sideLength / 2);
		ctx.stroke();

		// add the right triangle
		ctx.moveTo(arrowRight, scaleLabelBottom - sideLength / 2);
		ctx.lineTo(arrowRight - height, scaleLabelBottom);
		ctx.lineTo(arrowRight - height, scaleLabelBottom - sideLength);
		ctx.lineTo(arrowRight, scaleLabelBottom - sideLength / 2);
		ctx.closePath();
		ctx.fill();

		// write the word "High" at the bottom right horizontally
		ctx.save();
		ctx.translate(arrowRight + 12, scaleLabelBottom - sideLength / 2);
		ctx.textBaseline = "middle";
		ctx.textAlign = "left";
		ctx.fillStyle = textColor;
		ctx.fillText("High", 0, 0);

		ctx.restore();
	},
};

export const nineBoxBackground = {
	id: "nineBoxBackground",
	beforeDatasetsDraw(chart) {
		const {
			ctx,
			chartArea: { width, height, left },
			options: {
				layout: {
					padding: { top: paddingTop },
				},
			},
		} = chart;

		ctx.save();
		// Replace these colors with your palette
		const boxColors = [
			"#94C1DD",
			"#69A9CF",
			"#3E90C1", // First row
			"#BFDAEA",
			"#69A9CF",
			"#69A9CF", // Second row
			"#EAF3F8",
			"#BFDAEA",
			"#94C1DD", // Third row
		];

		const boxHeight = height / 3; // Size of each box
		const boxWidth = width / 3; // Size of each box
		const lineWidth = 2; // Width of the lines

		// Draw 9-box grid
		for (let i = 0; i < 3; i++) {
			for (let j = 0; j < 3; j++) {
				const x = left + j * boxWidth + lineWidth / 2;
				const y = i * boxHeight + lineWidth / 2 + paddingTop;

				ctx.fillStyle = boxColors[i * 3 + j];
				ctx.fillRect(x, y, boxWidth - lineWidth, boxHeight - lineWidth);
			}
		}

		ctx.restore();
	},
};
